module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-3"
  }, [_c('v-row', {
    staticClass: "mb-2"
  }, [_c('v-col', {
    attrs: {
      "col": "6"
    }
  }, [(_vm.buttonShow('create')) ? _c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.openCreatePaymentConsolidateModal(null)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-newspaper-plus")]), _vm._v("Create\n      ")], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('create')) ? _c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": _vm.openViewInvoiceModal
    }
  }, [_c('v-icon', [_vm._v("mdi-file-check")]), _vm._v(" View Invoices\n      ")], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.exportReportAllBatch()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-file-excel")]), _vm._v(" Export Excel")], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "6",
      "lg": "6"
    }
  }, [_c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_c('div', {
    staticClass: "mx-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "mx-2 mt-2",
    staticStyle: {
      "max-width": "200px"
    }
  }, [_c('v-menu', {
    ref: "globalLiveDatePicker",
    attrs: {
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "dense": "",
      "max-width": "290px",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "label": "Live Month",
            "readonly": "",
            "clearable": "",
            "outlined": "",
            "dense": "",
            "hide-details": "auto"
          },
          on: {
            "change": function($event) {
              return _vm.searchLiveDataFilter()
            }
          },
          model: {
            value: (_vm.globalFilter.searchliveDateMonth),
            callback: function($$v) {
              _vm.$set(_vm.globalFilter, "searchliveDateMonth", $$v)
            },
            expression: "globalFilter.searchliveDateMonth"
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }]),
    model: {
      value: (_vm.globalFilter.liveDatePicker),
      callback: function($$v) {
        _vm.$set(_vm.globalFilter, "liveDatePicker", $$v)
      },
      expression: "globalFilter.liveDatePicker"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "month",
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.globalFilter.searchliveDateMonth),
      callback: function($$v) {
        _vm.$set(_vm.globalFilter, "searchliveDateMonth", $$v)
      },
      expression: "globalFilter.searchliveDateMonth"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.cancelGlobalMonth('liveDate')
      }
    }
  }, [_vm._v("\n                Cancel\n              ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.searchGlobalMonthOk('liveDate')
      }
    }
  }, [_vm._v("\n                OK\n              ")])], 1)], 1)], 1), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "append-icon": "mdi-magnify",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    on: {
      "keyup": function($event) {
        return _vm.searchGlobal()
      }
    },
    model: {
      value: (_vm.searchText),
      callback: function($$v) {
        _vm.searchText = $$v
      },
      expression: "searchText"
    }
  })], 1)])], 1), _vm._v(" "), _vm._l((_vm.batches), function(batch, bindex) {
    return _c('div', {
      key: bindex,
      staticClass: "payment-consolidate-section",
      attrs: {
        "id": batch.batchNo
      }
    }, [_c('v-expansion-panels', {
      staticClass: "expansion-panels mb-5",
      attrs: {
        "multiple": "",
        "accordion": ""
      },
      model: {
        value: (batch.panel),
        callback: function($$v) {
          _vm.$set(batch, "panel", $$v)
        },
        expression: "batch.panel"
      }
    }, [_c('v-expansion-panel', {
      staticClass: "expansion-panel-main",
      attrs: {
        "expand": ""
      }
    }, [_c('v-expansion-panel-header', {
      staticClass: "expansion-panel-header"
    }, [_c('h3', {
      staticClass: "pa-0 ma-0"
    }, [_vm._v(_vm._s(batch.name))])]), _vm._v(" "), _c('v-expansion-panel-content', {
      staticClass: "expansion-panel-content"
    }, [_c('v-row', {
      staticClass: "no-gutters"
    }, [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "12",
        "lg": "12"
      }
    }, [_c('v-row', {
      staticClass: "action-section mb-3"
    }, [_c('v-col', {
      staticClass: "action-group-section",
      attrs: {
        "cols": "12",
        "sm": "3",
        "md": "3",
        "lg": "3"
      }
    }, [_c('div', {
      staticClass: "d-flex flex-row",
      staticStyle: {
        "gap": "3px"
      }
    }, [_c('v-btn', {
      staticClass: "mb-2",
      attrs: {
        "color": "warning",
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.exportReport(batch)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("mdi-file-excel")]), _vm._v(" Export Excel")], 1), _vm._v(" "), (_vm.allowedActions(batch.batchNo)) ? _c('div', [(batch.selectedPayments && batch.selectedPayments.length > 0 && batch.status !== _vm.paymentStatus.PAID) ? _c('v-btn', {
      staticClass: "mb-2",
      attrs: {
        "color": "warning",
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.openPaymentUpdateModal(batch.selectedPayments)
        }
      }
    }, [_vm._v("Update Status (" + _vm._s(batch.selectedPayments.length) + ")")]) : _vm._e(), _vm._v(" "), (_vm.isDeleteAction(batch.selectedPayments) && batch.status !== _vm.paymentStatus.PAID) ? _c('v-btn', {
      staticClass: "btn-payment-action",
      staticStyle: {
        "color": "#fff"
      },
      attrs: {
        "color": "red mb-2",
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.deleteMultipleReport()
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("mdi-delete")]), _vm._v(" Delete\n                      ")], 1) : _vm._e(), _vm._v(" "), (batch.selectedPayments && batch.selectedPayments.length > 0) ? _c('v-btn', {
      staticClass: "mb-2",
      attrs: {
        "color": "warning",
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.saveArchive(batch)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("mdi-archive")]), _vm._v(" Archive\n                      ")], 1) : _vm._e(), _vm._v(" "), (!batch.disableSaveEdit) ? _c('v-btn', {
      staticClass: "mb-2",
      attrs: {
        "color": "success",
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.saveChanges(batch.displayData, batch)
        }
      }
    }, [_vm._v("Save Changes")]) : _vm._e(), _vm._v(" "), (!batch.disableSaveEdit) ? _c('v-btn', {
      staticClass: "mb-2",
      attrs: {
        "color": "warning",
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.cancelEdit(batch.displayData, batch)
        }
      }
    }, [_vm._v("Cancel")]) : _vm._e()], 1) : _vm._e()], 1)]), _vm._v(" "), _c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "9",
        "md": "9",
        "lg": "9"
      }
    }, [_c('div', {
      staticClass: "d-flex justify-content-right float-right"
    }, [_c('div', {
      staticClass: "mx-2",
      staticStyle: {
        "min-width": "150px"
      }
    }, [_c('v-text-field', {
      attrs: {
        "append-icon": "mdi-magnify",
        "label": "Search",
        "single-line": "",
        "hide-details": ""
      },
      on: {
        "keyup": function($event) {
          return _vm.changeSearch(batch, batch.filter, batch.filter.search)
        }
      },
      model: {
        value: (batch.filter.search),
        callback: function($$v) {
          _vm.$set(batch.filter, "search", $$v)
        },
        expression: "batch.filter.search"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "mx-2"
    }, [_c('v-checkbox', {
      staticClass: "imported-only-checkbox",
      staticStyle: {
        "min-width": "150px",
        "max-width": "150px"
      },
      attrs: {
        "label": "Imported Only",
        "color": "secondary",
        "value": false,
        "hide-details": ""
      },
      on: {
        "change": function($event) {
          return _vm.searchFilter(batch)
        }
      },
      model: {
        value: (batch.filter.imported),
        callback: function($$v) {
          _vm.$set(batch.filter, "imported", $$v)
        },
        expression: "batch.filter.imported"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "mx-2 mt-2",
      staticStyle: {
        "max-width": "200px"
      }
    }, [_c('v-autocomplete', {
      attrs: {
        "label": "All CC",
        "items": _vm.CCUsers,
        "item-text": "name",
        "item-value": "id",
        "dense": "",
        "outlined": "",
        "hide-details": ""
      },
      on: {
        "change": function($event) {
          return _vm.searchFilter(batch)
        }
      },
      model: {
        value: (batch.filter.cc),
        callback: function($$v) {
          _vm.$set(batch.filter, "cc", $$v)
        },
        expression: "batch.filter.cc"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "mx-2 mt-2",
      staticStyle: {
        "max-width": "200px"
      }
    }, [_c('v-autocomplete', {
      attrs: {
        "label": "",
        "items": _vm.filterCountries,
        "item-text": "name",
        "item-value": "name",
        "dense": "",
        "outlined": "",
        "hide-details": ""
      },
      on: {
        "change": function($event) {
          return _vm.searchFilter(batch)
        }
      },
      model: {
        value: (batch.filter.country),
        callback: function($$v) {
          _vm.$set(batch.filter, "country", $$v)
        },
        expression: "batch.filter.country"
      }
    })], 1), _vm._v(" "), (_vm.allowFilters('paymentDate', batch.batchNo)) ? _c('div', {
      staticClass: "mx-2 mt-2"
    }, [_c('v-menu', {
      ref: "paymentDatePicker",
      refInFor: true,
      attrs: {
        "close-on-content-click": false,
        "transition": "scale-transition",
        "offset-y": "",
        "dense": "",
        "max-width": "290px",
        "min-width": "auto"
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;
          var attrs = ref.attrs;

          return [_c('v-text-field', _vm._g(_vm._b({
            attrs: {
              "label": "Payment Date",
              "readonly": "",
              "clearable": "",
              "outlined": "",
              "dense": "",
              "hide-details": "auto"
            },
            on: {
              "change": function($event) {
                return _vm.searchFilter(batch)
              }
            },
            model: {
              value: (batch.filter.searchPaymentDateMonth),
              callback: function($$v) {
                _vm.$set(batch.filter, "searchPaymentDateMonth", $$v)
              },
              expression: "batch.filter.searchPaymentDateMonth"
            }
          }, 'v-text-field', attrs, false), on))]
        }
      }], null, true),
      model: {
        value: (batch.filter.paymentDatePicker),
        callback: function($$v) {
          _vm.$set(batch.filter, "paymentDatePicker", $$v)
        },
        expression: "batch.filter.paymentDatePicker"
      }
    }, [_vm._v(" "), _c('v-date-picker', {
      attrs: {
        "type": "month",
        "no-title": "",
        "scrollable": ""
      },
      model: {
        value: (batch.filter.searchPaymentDateMonth),
        callback: function($$v) {
          _vm.$set(batch.filter, "searchPaymentDateMonth", $$v)
        },
        expression: "batch.filter.searchPaymentDateMonth"
      }
    }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
      attrs: {
        "text": "",
        "color": "secondary"
      },
      on: {
        "click": function($event) {
          return _vm.cancelMonth(batch, 'paymentDate')
        }
      }
    }, [_vm._v("\n                              Cancel\n                          ")]), _vm._v(" "), _c('v-btn', {
      attrs: {
        "text": "",
        "color": "secondary"
      },
      on: {
        "click": function($event) {
          return _vm.searchMonthOk(batch, 'paymentDate')
        }
      }
    }, [_vm._v("\n                              OK\n                          ")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "mx-2"
    }, [_c('v-btn', {
      staticClass: "mt-3",
      attrs: {
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.resetFilter(batch)
        }
      }
    }, [_vm._v("Reset")])], 1)])])], 1)], 1), _vm._v(" "), _c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "12",
        "lg": "12"
      }
    }, [_c('v-data-table', {
      key: _vm.dataTableKey,
      staticClass: "table-small payment-consolidate-table elevation-1",
      attrs: {
        "headers": batch.headers,
        "items": batch.displayData,
        "items-per-page": 10,
        "search": batch.filter.workingSearch,
        "no-data-text": 'Empty list',
        "show-select": "",
        "single-select": false
      },
      on: {
        "toggle-select-all": _vm.selectAllPayments,
        "current-items": _vm.getFiltered
      },
      scopedSlots: _vm._u([{
        key: "item.data-table-select",
        fn: function(ref) {
          var item = ref.item;

          return [_c('v-checkbox', {
            staticClass: "custom-checkbox",
            attrs: {
              "label": "",
              "value": item,
              "color": "grey darken-2"
            },
            model: {
              value: (batch.selectedPayments),
              callback: function($$v) {
                _vm.$set(batch, "selectedPayments", $$v)
              },
              expression: "batch.selectedPayments"
            }
          })]
        }
      }, {
        key: "item.instagram",
        fn: function(ref) {
          var item = ref.item;

          return [(item.isFacebook || item.fbOwner) ? _c('a', {
            attrs: {
              "href": 'https://facebook.com/' + item.instagram,
              "target": "_blank"
            }
          }, [_c('v-icon', {
            staticStyle: {
              "color": "#1877F2 !important"
            },
            attrs: {
              "small": ""
            }
          }, [_vm._v("mdi-facebook")]), _vm._v(" @" + _vm._s(item.instagram))], 1) : (item.isTikTok || item.tiktokOwner) ? _c('a', {
            attrs: {
              "href": 'https://www.tiktok.com/@' + item.instagram,
              "target": "_blank"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/img/tiktok-32.png",
              "width": "20px"
            }
          }), _vm._v(" @" + _vm._s(item.instagram))]) : (item.isYoutube || item.youtubeOwner) ? _c('a', {
            attrs: {
              "href": 'https://youtube.com/@' + item.instagram,
              "target": "_blank"
            }
          }, [_c('v-icon', {
            staticStyle: {
              "color": "#FF0000 !important"
            }
          }, [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(item.instagram))], 1) : (_vm.isLinkedInPayment(item) || item.linkedinOwner) ? _c('a', {
            attrs: {
              "href": 'https://www.linkedin.com/in/' + item.instagram,
              "target": "_blank",
              "rel": "noopener noreferrer"
            }
          }, [_c('v-icon', {
            staticStyle: {
              "color": "#0A66C2 !important"
            },
            attrs: {
              "small": ""
            }
          }, [_vm._v("mdi-linkedin")]), _vm._v(" @" + _vm._s(item.instagram))], 1) : (item.twitterOwner || _vm.isTwitterPayment(item)) ? _c('a', {
            attrs: {
              "href": 'https://x.com/' + item.instagram,
              "target": "_blank",
              "rel": "noopener noreferrer"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/img/x-logo.svg",
              "width": "15px",
              "alt": "",
              "aria-hidden": "true"
            }
          }), _vm._v(" @" + _vm._s(item.instagram))]) : (item.isXHS || item.xhsOwner) ? _c('a', {
            attrs: {
              "href": 'https://www.xiaohongshu.com/user/profile/' + item.xhsID,
              "target": "_blank"
            }
          }, [_c('img', {
            staticClass: "payment-xhs-logo",
            attrs: {
              "src": "/static/img/xhs-black.png",
              "width": "20px"
            }
          }), _vm._v(" " + _vm._s(item.fullName || item.instagram))]) : _c('a', {
            attrs: {
              "href": 'https://www.instagram.com/' + item.instagram,
              "target": "_blank"
            }
          }, [_c('v-icon', {
            staticStyle: {
              "color": "#E1306C !important"
            },
            attrs: {
              "small": ""
            }
          }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(item.instagram))], 1), _vm._v(" "), (item.platformHandlesObj && item.platformHandlesObj.length > 1) ? _c('v-menu', {
            attrs: {
              "bottom": "",
              "origin": "center center",
              "transition": "scale-transition"
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;
                var attrs = ref.attrs;

                return [_c('v-btn', _vm._g(_vm._b({
                  staticStyle: {
                    "min-width": "0",
                    "padding": "0",
                    "margin-left": "-9px",
                    "margin-top": "-3px"
                  },
                  attrs: {
                    "dark": "",
                    "text": ""
                  }
                }, 'v-btn', attrs, false), on), [_c('v-tooltip', {
                  attrs: {
                    "bottom": ""
                  },
                  scopedSlots: _vm._u([{
                    key: "activator",
                    fn: function(ref) {
                      var on = ref.on;

                      return [_c('v-icon', _vm._g({
                        staticClass: "ml-2",
                        attrs: {
                          "color": "warning",
                          "small": ""
                        }
                      }, on), [_vm._v("mdi-chevron-down-circle")])]
                    }
                  }], null, true)
                }, [_vm._v(" "), _c('span', [_vm._v("Multiple Accounts detected")])])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('v-list', _vm._l((item.platformHandlesObj), function(obj, i) {
            return _c('v-list-item', {
              key: i
            }, [_c('v-list-item-title', [(obj.type === 'xhs') ? _c('a', [_c('img', {
              staticClass: "payment-xhs-logo",
              attrs: {
                "src": "/static/img/xhs-black.png",
                "width": "20px"
              }
            }), _vm._v(" @" + _vm._s(obj.handle))]) : (obj.type === 'facebook') ? _c('a', [_c('v-icon', {
              staticStyle: {
                "color": "#1877F2 !important"
              },
              attrs: {
                "small": ""
              }
            }, [_vm._v("mdi-facebook")]), _vm._v(" @" + _vm._s(obj.handle))], 1) : (obj.type === 'tiktok') ? _c('a', [_c('img', {
              attrs: {
                "src": "/static/img/tiktok-32.png",
                "width": "20px"
              }
            }), _vm._v(" @" + _vm._s(obj.handle))]) : (obj.type === 'youtube') ? _c('a', [_c('v-icon', {
              staticStyle: {
                "color": "#FF0000 !important"
              }
            }, [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(obj.handle))], 1) : (obj.type === 'linkedin') ? _c('a', [_c('v-icon', {
              staticStyle: {
                "color": "#0A66C2 !important"
              },
              attrs: {
                "small": ""
              }
            }, [_vm._v("mdi-linkedin")]), _vm._v(" @" + _vm._s(obj.handle))], 1) : (obj.type === 'twitter' || obj.type === 'x') ? _c('a', [_c('img', {
              attrs: {
                "src": "/static/img/x-logo.svg",
                "width": "15px",
                "alt": "",
                "aria-hidden": "true"
              }
            }), _vm._v(" @" + _vm._s(obj.handle))]) : _c('a', [_c('v-icon', {
              staticStyle: {
                "color": "#E1306C !important"
              },
              attrs: {
                "small": ""
              }
            }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(obj.handle))], 1)])], 1)
          }), 1)], 1) : _vm._e(), _vm._v(" "), (item.imported) ? _c('v-icon', {
            attrs: {
              "small": "",
              "color": "secondary",
              "data-toggle": "tooltip",
              "data-placement": "bottom",
              "title": "Imported"
            }
          }, [_vm._v("mdi-newspaper-plus")]) : _vm._e()]
        }
      }, {
        key: "item.liveDate",
        fn: function(ref) {
          var item = ref.item;

          return [_c('div', {
            staticStyle: {
              "min-width": "70px"
            }
          }, [_vm._v(_vm._s(item.liveDate))])]
        }
      }, {
        key: "item.dueDate",
        fn: function(ref) {
          var item = ref.item;

          return [(item.overdue) ? _c('div', [_c('v-chip', {
            attrs: {
              "small": "",
              "color": "red",
              "text-color": "white"
            }
          }, [_vm._v("\n                    " + _vm._s(item.dueDate) + "\n                    ")])], 1) : (item.early) ? _c('div', [_c('v-chip', {
            attrs: {
              "small": "",
              "color": "yellow",
              "text-color": "black"
            }
          }, [_vm._v("\n                    " + _vm._s(item.dueDate) + "\n                    ")])], 1) : _c('div', {
            staticStyle: {
              "min-width": "70px"
            }
          }, [_vm._v(_vm._s(item.dueDate))])]
        }
      }, {
        key: "item.swiftCode",
        fn: function(ref) {
          var item = ref.item;

          return [(item.swiftCodeEdit === false) ? _c('div', {
            staticClass: "item-edit",
            on: {
              "click": function($event) {
                return _vm.openEditItem(item, 'swiftCode', batch)
              }
            }
          }, [_c('td', {
            staticClass: "text-xs-left",
            staticStyle: {
              "min-width": "75px"
            }
          }, [_vm._v(_vm._s(item.swiftCode))])]) : _c('div', [_c('v-text-field', {
            staticClass: "input-field mt-3",
            attrs: {
              "dense": "",
              "outlined": ""
            },
            nativeOn: {
              "keyup": function($event) {
                return _vm.changeSwiftCode(item)
              }
            },
            model: {
              value: (item.swiftCode),
              callback: function($$v) {
                _vm.$set(item, "swiftCode", $$v)
              },
              expression: "item.swiftCode"
            }
          })], 1)]
        }
      }, {
        key: "item.bankAccount",
        fn: function(ref) {
          var item = ref.item;

          return [(item.bankAccountEdit === false) ? _c('div', {
            staticClass: "item-edit",
            on: {
              "click": function($event) {
                return _vm.openEditItem(item, 'bankAccount', batch)
              }
            }
          }, [_c('td', {
            staticClass: "text-xs-left",
            staticStyle: {
              "min-width": "75px"
            }
          }, [_vm._v(_vm._s(item.bankAccount))])]) : _c('div', [_c('v-text-field', _vm._g({
            staticClass: "input-field mt-3",
            attrs: {
              "dense": "",
              "outlined": ""
            },
            model: {
              value: (item.bankAccount),
              callback: function($$v) {
                _vm.$set(item, "bankAccount", $$v)
              },
              expression: "item.bankAccount"
            }
          }, _vm.on))], 1)]
        }
      }, {
        key: "item.username",
        fn: function(ref) {
          var item = ref.item;

          return [(item.usernameEdit === false) ? _c('div', {
            staticClass: "item-edit",
            on: {
              "click": function($event) {
                return _vm.openEditItem(item, 'username', batch)
              }
            }
          }, [_c('td', {
            staticClass: "text-xs-left",
            staticStyle: {
              "min-width": "75px"
            }
          }, [_vm._v(_vm._s(item.username))])]) : _c('div', [_c('v-text-field', _vm._g({
            staticClass: "input-field mt-3",
            attrs: {
              "dense": "",
              "outlined": ""
            },
            model: {
              value: (item.username),
              callback: function($$v) {
                _vm.$set(item, "username", $$v)
              },
              expression: "item.username"
            }
          }, _vm.on))], 1)]
        }
      }, {
        key: "item.country",
        fn: function(ref) {
          var item = ref.item;

          return [(item.countryEdit === false) ? _c('div', {
            staticClass: "item-edit",
            on: {
              "click": function($event) {
                return _vm.openEditItem(item, 'country', batch)
              }
            }
          }, [_c('td', {
            staticClass: "text-xs-left",
            staticStyle: {
              "min-width": "75px"
            }
          }, [_vm._v(_vm._s(item.country))])]) : _c('div', {
            staticClass: "mt-3"
          }, [_c('v-select', {
            attrs: {
              "label": "",
              "items": _vm.countries,
              "item-text": "name",
              "item-value": "name",
              "dense": "",
              "outlined": ""
            },
            on: {
              "change": _vm.changeCountry
            },
            model: {
              value: (item.country),
              callback: function($$v) {
                _vm.$set(item, "country", $$v)
              },
              expression: "item.country"
            }
          })], 1)]
        }
      }, {
        key: "item.bankName",
        fn: function(ref) {
          var item = ref.item;

          return [(item.bankNameEdit === false) ? _c('div', {
            staticClass: "item-edit",
            on: {
              "click": function($event) {
                return _vm.openEditItem(item, 'bankName', batch)
              }
            }
          }, [_c('td', {
            staticClass: "text-xs-left",
            staticStyle: {
              "min-width": "75px"
            }
          }, [_vm._v(_vm._s(typeof item.bankName === 'object' ? item.bankName.bank : item.bankName))])]) : _c('div', {
            staticClass: "mt-3"
          }, [_c('v-combobox', {
            attrs: {
              "items": _vm.bankNames,
              "label": "Bank Name (select your bank)",
              "item-text": "bank",
              "item-value": "bank",
              "search-input": _vm.newBankName,
              "attach": "",
              "dense": "",
              "outlined": ""
            },
            on: {
              "update:searchInput": function($event) {
                _vm.newBankName = $event
              },
              "update:search-input": function($event) {
                _vm.newBankName = $event
              },
              "change": function($event) {
                return _vm.changeBankName(item)
              }
            },
            scopedSlots: _vm._u([{
              key: "no-data",
              fn: function() {
                return [_c('v-list-item', [(_vm.newBankName) ? _c('span', {
                  staticClass: "subheading pr-2"
                }, [_vm._v(_vm._s(_vm.newBankName))]) : _vm._e()])]
              },
              proxy: true
            }], null, true),
            model: {
              value: (item.bankName),
              callback: function($$v) {
                _vm.$set(item, "bankName", $$v)
              },
              expression: "item.bankName"
            }
          })], 1)]
        }
      }, {
        key: "item.email",
        fn: function(ref) {
          var item = ref.item;

          return [(item.emailEdit === false) ? _c('div', {
            staticClass: "item-edit",
            on: {
              "click": function($event) {
                return _vm.openEditItem(item, 'email', batch)
              }
            }
          }, [_c('td', {
            staticClass: "text-xs-left",
            staticStyle: {
              "min-width": "75px"
            }
          }, [_vm._v(_vm._s(item.email))])]) : _c('div', [_c('v-text-field', _vm._g({
            staticClass: "input-field mt-3",
            attrs: {
              "dense": "",
              "outlined": ""
            },
            model: {
              value: (item.email),
              callback: function($$v) {
                _vm.$set(item, "email", $$v)
              },
              expression: "item.email"
            }
          }, _vm.on))], 1)]
        }
      }, {
        key: "item.amount",
        fn: function(ref) {
          var item = ref.item;

          return [(item.amountLocked) ? _c('div', [_c('td', {
            staticClass: "text-xs-left",
            staticStyle: {
              "min-width": "75px"
            }
          }, [_vm._v("-")])]) : _c('div', [_c('td', {
            staticClass: "text-xs-left",
            staticStyle: {
              "min-width": "75px"
            }
          }, [_c('v-btn', _vm._g(_vm._b({
            attrs: {
              "color": "secondary",
              "small": "",
              "text": ""
            }
          }, 'v-btn', _vm.attrs, false), _vm.on), [(!item.GSTPercent) ? _c('span', [_c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('div', _vm._g({}, on), [_vm._v("\n                                " + _vm._s(_vm.utils.currencySym(item.currency)) + " " + _vm._s(_vm._f("thousandSeprator")(item.amount)) + "\n                              ")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(item.currency) + " " + _vm._s(_vm._f("thousandSeprator")(item.amount)))]), _c('br'), _vm._v(" "), (item.sgdAmt) ? _c('span', [_vm._v("Estimated SGD: " + _vm._s(item.sgdAmt))]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (item.GSTPercent) ? _c('span', {
            attrs: {
              "data-toggle": "tooltip",
              "data-placement": "top",
              "title": _vm.displayGSTText(item)
            }
          }, [_c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('div', _vm._g({}, on), [_vm._v("\n                                " + _vm._s(_vm.utils.currencySym(item.currency)) + " " + _vm._s(_vm._f("thousandSeprator")(item.amount)) + "\n                              ")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(item.currency) + " " + _vm._s(_vm._f("thousandSeprator")(item.amount)))]), _c('br'), _vm._v(" "), (item.sgdAmt) ? _c('span', [_vm._v("Estimated SGD: " + _vm._s(item.sgdAmt))]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (item.specialPayment) ? _c('v-icon', {
            attrs: {
              "small": "",
              "color": "secondary",
              "data-toggle": "tooltip",
              "data-placement": "bottom",
              "title": "Special Payment Terms"
            }
          }, [_vm._v("mdi-alert-circle-outline")]) : _vm._e(), _vm._v(" "), (item.GSTPercent) ? _c('v-icon', {
            attrs: {
              "small": "",
              "color": "secondary",
              "data-toggle": "tooltip",
              "data-placement": "top",
              "title": "GST enabled"
            }
          }, [_vm._v("mdi-alert-circle")]) : _vm._e()], 1), _vm._v(" "), (batch.status === _vm.paymentStatus.PAID && item.currency !== 'SGD') ? _c('v-btn', {
            attrs: {
              "color": "secondary",
              "x-small": ""
            },
            on: {
              "click": function($event) {
                $event.stopPropagation();
                return _vm.openActualAmountDialog(item)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "x-small": ""
            }
          }, [_vm._v("edit")]), _vm._v(" "), (!item.actualAmount) ? _c('span', [_vm._v("Actual Amount")]) : _vm._e(), _vm._v(" "), (item.actualAmount) ? _c('span', [_vm._v("S$ " + _vm._s(_vm._f("thousandSeprator")(item.actualAmount)))]) : _vm._e()], 1) : _vm._e()], 1)])]
        }
      }, {
        key: "item.PVNumber",
        fn: function(ref) {
          var item = ref.item;

          return [(item.PVNumberEdit === false) ? _c('div', {
            staticClass: "item-edit",
            on: {
              "click": function($event) {
                return _vm.openEditItem(item, 'PVNumber', batch)
              }
            }
          }, [_c('td', {
            staticClass: "text-xs-left",
            staticStyle: {
              "min-width": "75px"
            }
          }, [_vm._v(_vm._s(item.PVNumber))])]) : _c('div', [_c('v-text-field', _vm._g({
            staticClass: "input-field mt-3",
            attrs: {
              "dense": "",
              "outlined": ""
            },
            model: {
              value: (item.PVNumber),
              callback: function($$v) {
                _vm.$set(item, "PVNumber", $$v)
              },
              expression: "item.PVNumber"
            }
          }, _vm.on))], 1)]
        }
      }, {
        key: "item.paymentStatus",
        fn: function(ref) {
          var item = ref.item;

          return [(item.paymentStatusEdit === false) ? _c('div', {
            on: {
              "click": function($event) {
                return _vm.openEditItem(item, 'paymentStatus', batch)
              }
            }
          }, [_c('td', {
            staticClass: "text-xs-left",
            staticStyle: {
              "min-width": "50px"
            }
          }, [_vm._v(_vm._s(_vm.getPaymentStatus(item.paymentStatus)))])]) : _c('div', [_c('td', {
            staticClass: "text-xs-left",
            staticStyle: {
              "min-width": "50px"
            }
          }, [_c('v-select', {
            staticClass: "input-field pt-3",
            attrs: {
              "items": _vm.filterPaymentStatusOptions(item),
              "item-value": "status",
              "item-text": "display",
              "label": "Payment Status",
              "dense": "",
              "outlined": ""
            },
            on: {
              "change": function($event) {
                return _vm.changePaymentStatus(item)
              }
            },
            model: {
              value: (item.paymentStatus),
              callback: function($$v) {
                _vm.$set(item, "paymentStatus", $$v)
              },
              expression: "item.paymentStatus"
            }
          })], 1)])]
        }
      }, {
        key: "item.paymentDate",
        fn: function(ref) {
          var item = ref.item;

          return [(item.paymentDateEdit === false) ? _c('div', {
            staticClass: "item-edit",
            on: {
              "click": function($event) {
                return _vm.openEditItem(item, 'paymentDate', batch)
              }
            }
          }, [_c('td', {
            staticClass: "text-xs-left",
            staticStyle: {
              "min-width": "75px"
            }
          }, [_vm._v(_vm._s(item.paymentDate))])]) : _c('div', [_c('v-text-field', _vm._g({
            staticClass: "input-field mt-3",
            attrs: {
              "dense": "",
              "outlined": ""
            },
            model: {
              value: (item.paymentDate),
              callback: function($$v) {
                _vm.$set(item, "paymentDate", $$v)
              },
              expression: "item.paymentDate"
            }
          }, _vm.on))], 1)]
        }
      }, {
        key: "item.paymentSubmissionDate",
        fn: function(ref) {
          var item = ref.item;

          return [_c('div', {
            staticClass: "item-edit"
          }, [_c('td', {
            staticClass: "text-xs-left",
            staticStyle: {
              "min-width": "75px"
            }
          }, [_vm._v(_vm._s(item.paymentSubmissionDate))])])]
        }
      }, {
        key: "item.bankReference",
        fn: function(ref) {
          var item = ref.item;

          return [(item.bankReferenceEdit === false) ? _c('div', {
            staticClass: "item-edit",
            on: {
              "click": function($event) {
                return _vm.openEditItem(item, 'bankReference', batch)
              }
            }
          }, [_c('td', {
            staticClass: "text-xs-left",
            staticStyle: {
              "min-width": "75px"
            }
          }, [_vm._v(_vm._s(item.bankReference))])]) : _c('div', [_c('v-text-field', _vm._g({
            staticClass: "input-field mt-3",
            attrs: {
              "dense": "",
              "outlined": ""
            },
            model: {
              value: (item.bankReference),
              callback: function($$v) {
                _vm.$set(item, "bankReference", $$v)
              },
              expression: "item.bankReference"
            }
          }, _vm.on))], 1)]
        }
      }, {
        key: "item.action",
        fn: function(ref) {
          var item = ref.item;

          return [_c('div', {
            staticClass: "pt-2 pb-2 px-2"
          }, [_c('div', {
            staticClass: "pt-1"
          }, [_c('v-btn', {
            staticClass: "btn-payment-action",
            attrs: {
              "to": '/campaign-report-internal?id=' + item.campaignID,
              "target": "_blank",
              "color": "info",
              "small": ""
            }
          }, [_c('i', {
            staticClass: "fas fa-eye"
          }), _vm._v(" Campaign Report\n                      ")])], 1), _vm._v(" "), _c('div', {
            staticClass: "pt-1"
          }, [_c('v-btn', {
            staticClass: "btn-payment-action",
            attrs: {
              "color": "warning",
              "small": ""
            },
            on: {
              "click": function($event) {
                return _vm.openPaymentInvoiceModal(item)
              }
            }
          }, [_c('i', {
            staticClass: "fas fa-upload"
          }), _vm._v(" Manage Invoices\n                      ")])], 1), _vm._v(" "), (item.paymentStatus !== _vm.paymentStatus.PAID) ? _c('div', {
            staticClass: "pt-1"
          }, [_c('v-badge', {
            attrs: {
              "value": _vm.getNoteUnreadCount(item),
              "content": _vm.getNoteUnreadCount(item),
              "color": "green",
              "overlap": ""
            },
            on: {
              "click": function($event) {
                $event.stopPropagation();
                return _vm.openReportNotesDialog(item)
              }
            }
          }, [_c('v-btn', {
            staticClass: "btn-payment-action",
            attrs: {
              "color": "warning",
              "small": ""
            },
            on: {
              "click": function($event) {
                $event.stopPropagation();
                return _vm.openReportNotesDialog(item)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "color": "white",
              "small": ""
            }
          }, [_vm._v("edit")]), _vm._v(" Edit Note\n                        ")], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
            staticClass: "pt-1"
          }, [(item.batchNo === 'imported') ? _c('v-btn', {
            staticClass: "btn-payment-action",
            staticStyle: {
              "color": "#fff"
            },
            attrs: {
              "color": "red",
              "small": ""
            },
            on: {
              "click": function($event) {
                return _vm.deleteReport(item.id, item)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "color": "white",
              "small": ""
            }
          }, [_vm._v("mdi-delete")]), _vm._v(" Delete\n                      ")], 1) : _vm._e()], 1)])]
        }
      }], null, true),
      model: {
        value: (batch.selectedPayments),
        callback: function($$v) {
          _vm.$set(batch, "selectedPayments", $$v)
        },
        expression: "batch.selectedPayments"
      }
    }, [_vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _c('template', {
      slot: "body.append"
    }, [_c('tr', [_c('th', {
      staticClass: "subtitle-2",
      attrs: {
        "colspan": "9"
      }
    }, [_vm._v("Total Amount:")]), _vm._v(" "), _c('th', {
      attrs: {
        "colspan": "12"
      }
    }, [_c('v-chip', {
      attrs: {
        "small": "",
        "color": "primary",
        "text-color": "white"
      }
    }, [_c('v-icon', {
      staticClass: "mr-0",
      attrs: {
        "small": "",
        "left": ""
      }
    }, [_vm._v("mdi-currency-usd")]), _vm._v(" " + _vm._s(_vm.fixTwoDec(batch.totalAmount)) + "\n                      ")], 1)], 1)])])], 2)], 1)], 1)], 1)], 1)], 1)], 1)
  }), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('update-payment-info-modal', {
    attrs: {
      "payments": _vm.selectedPayments,
      "selectedPaymentStatus": _vm.selectedPaymentStatus
    },
    on: {
      "updated": _vm.getPaymentConsolidateReport
    },
    model: {
      value: (_vm.paymentInfoDialog),
      callback: function($$v) {
        _vm.paymentInfoDialog = $$v
      },
      expression: "paymentInfoDialog"
    }
  }), _vm._v(" "), _c('partial-amount-modal', {
    attrs: {
      "report": _vm.selectedReport
    },
    on: {
      "updated": _vm.getPaymentConsolidateReport
    },
    model: {
      value: (_vm.partialAmountDialog),
      callback: function($$v) {
        _vm.partialAmountDialog = $$v
      },
      expression: "partialAmountDialog"
    }
  }), _vm._v(" "), _c('actual-amount-modal', {
    attrs: {
      "report": _vm.selectedReport
    },
    on: {
      "updated": _vm.getPaymentConsolidateReport
    },
    model: {
      value: (_vm.actualAmountDialog),
      callback: function($$v) {
        _vm.actualAmountDialog = $$v
      },
      expression: "actualAmountDialog"
    }
  }), _vm._v(" "), _c('report-notes-modal', {
    attrs: {
      "value": _vm.reportNotesDialog,
      "data": _vm.reportNotesData
    },
    on: {
      "savedNotes": _vm.getPaymentConsolidateReport
    },
    model: {
      value: (_vm.reportNotesDialog),
      callback: function($$v) {
        _vm.reportNotesDialog = $$v
      },
      expression: "reportNotesDialog"
    }
  }), _vm._v(" "), _c('create-payment-consolidate-modal', {
    attrs: {
      "value": _vm.createPaymentConsolidateDialog,
      "reports": _vm.consolidateReports,
      "editData": _vm.editInvoice,
      "reportUpdate": _vm.reportUpdate
    },
    on: {
      "created": _vm.refreshPayCons
    },
    model: {
      value: (_vm.createPaymentConsolidateDialog),
      callback: function($$v) {
        _vm.createPaymentConsolidateDialog = $$v
      },
      expression: "createPaymentConsolidateDialog"
    }
  }), _vm._v(" "), _c('upload-invoice-modal', {
    attrs: {
      "value": _vm.invoiceDialog
    },
    on: {
      "created": _vm.getPaymentConsolidateReport
    },
    model: {
      value: (_vm.invoiceDialog),
      callback: function($$v) {
        _vm.invoiceDialog = $$v
      },
      expression: "invoiceDialog"
    }
  }), _vm._v(" "), _c('uploaded-invoice-list-modal', {
    attrs: {
      "value": _vm.invoiceViewDialog
    },
    on: {
      "updated": _vm.getPaymentConsolidateReport,
      "openEdit": _vm.openCreatePaymentConsolidateModal
    },
    model: {
      value: (_vm.invoiceViewDialog),
      callback: function($$v) {
        _vm.invoiceViewDialog = $$v
      },
      expression: "invoiceViewDialog"
    }
  }), _vm._v(" "), _c('payment-invoice-modal', {
    attrs: {
      "value": _vm.paymentInvoiceDialog,
      "payment": _vm.selectedInvoicePayment
    },
    on: {
      "updated": _vm.refreshPayCons
    },
    model: {
      value: (_vm.paymentInvoiceDialog),
      callback: function($$v) {
        _vm.paymentInvoiceDialog = $$v
      },
      expression: "paymentInvoiceDialog"
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f39eebe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Finance/PaymentConsolidation.vue
// module id = 2003
// module chunks = 0